module.exports = __webpack_public_path__ + "img/airline.b0be40e2.png";